var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("table", { staticClass: "table is-fullwidth is-narrow" }, [
      _vm._m(0),
      _c("tfoot", [
        _c("tr", [
          _c("th", { attrs: { colspan: "2" } }),
          _c("th", [_vm._v("Subtotal")]),
          _c("th", [_vm._v(_vm._s(_vm.subTotalCurrency))]),
          _c("th")
        ]),
        _c("tr", [
          _c("th", { attrs: { colspan: "2" } }),
          _c("th", [_vm._v("Total")]),
          _c("th", [_vm._v(_vm._s(_vm.totalCurrency))]),
          _c("th")
        ])
      ]),
      _c(
        "tbody",
        _vm._l(_vm.concepts, function(concept, index) {
          return _c("tr", { key: index }, [
            _c("td", [
              _vm._v(
                "\n          " + _vm._s(concept.description) + "\n        "
              )
            ]),
            _c("td", [
              _vm._v("\n          " + _vm._s(concept.quantity) + "\n        ")
            ]),
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm._f("toCurrency")(concept.unit, _vm.voucherCurrency)
                  ) +
                  "\n        "
              )
            ]),
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm._f("toCurrency")(
                      concept.unit * concept.quantity,
                      _vm.voucherCurrency
                    )
                  ) +
                  "\n        "
              )
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Descripción")]),
        _c("th", [_vm._v("Cantidad")]),
        _c("th", [_vm._v("Valor unitario")]),
        _c("th", [_vm._v("Importe")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }